import Utility from "./utility";
import 'mmenu-js';
declare const Mmenu: any;

class Header {
    menu: any;
    utility = Utility;
    debounceTimer: number | undefined;

    constructor() {
        this.init();
    }

    init() {
        // set up our universal constants
        const secondaryNav = document.querySelector('.secondary-nav') as HTMLElement | null;
        const bannerCloseButton = document.getElementById('sitewide-banner-close');
        const slideMenu = document.querySelector<HTMLElement>('.slide-menu');
        const sitewideBanner = document.querySelector('.sitewide-banner') as HTMLElement | null;
        let isBannerClosed = false;

        const infoDropdown: HTMLSelectElement | null = document.querySelector('.info-dropdown select');
        const infoDropdownBtn: HTMLButtonElement | null = document.querySelector('.info-dropdown button');

        // Initialize the mobile nav slide menu
        this.menu = new Mmenu("#slide-nav", {
            navbar: {
                title: "Menu"
            },
            offCanvas: {
                position: "right-front"
            }
        });

        const menuAPI = this.menu.API;

        let currentPagePath = document.location.pathname;
        const menuItems = document.querySelectorAll('li.mm-listitem');

        //tweak current page pathname for special sites/pages
        if(currentPagePath.includes("/news")) {
            currentPagePath = "/news";
        } else if(currentPagePath.includes("/events")){
            currentPagePath = "/events";
        } else if(currentPagePath.includes("/courses-and-certificates")){
            currentPagePath = "/continuing-education/courses-and-certificates";
        } else if(currentPagePath.includes("/programs-and-courses")){
            currentPagePath = "/programs-and-courses";
        }

        //mobile nav open to the location of the current page in the site nav
        menuItems.forEach(item => {
            const itemLink: HTMLAnchorElement | null = item.querySelector('a');
            let itemPath = "";
            //if link exists within sait.ca
            if(itemLink && itemLink.href.includes("https://www.sait.ca")){
                itemPath = itemLink.href.substring(19).replace("/index","").replace(".html",""); //get everything after https://www.sait.ca/ in link href
                //console.log(itemPath)
            }

            if(itemPath == currentPagePath){
                const parentPanel = item.closest(".mm-panel"); //open to parent panel
                menuAPI.setSelected(item);
                menuAPI.openPanel(parentPanel);
            }
        });
        
        this.calculateCombinedHeight(secondaryNav, sitewideBanner);
        this.setSlideMenuAttributes(slideMenu, secondaryNav, sitewideBanner);
        this.updateBlockerElementWithContent();
        this.setCloseButtonPosition();
        this.handleMobileNavButtonVisibility();
        this.mobileMenuBacklinksClasses();
        this.changeTextContentOfBacklinks('.mm-navbar__title span', 'Back');
        this.assignFirstLastClassesToElements();
        this.desktopDropdownHandlers();
        this.equalizeDropdownHeights(); // Call the function immediately to apply the heights
        this.adjustHeaderNav(secondaryNav, slideMenu, sitewideBanner, isBannerClosed);

        // Event listeners
        document.addEventListener('closed', () => {
            isBannerClosed = true;
            this.calculateCombinedHeight(secondaryNav, sitewideBanner);
        });

        window.addEventListener('scroll', this.throttle(() => this.adjustHeaderNav(secondaryNav, slideMenu, sitewideBanner, isBannerClosed), 100));

        // This will trigger whenever the visual viewport changes, including when the address bar appears/disappears
        if (window.visualViewport) {

            window.addEventListener('resize', () => this.debouncer(() => {
                this.equalizeDropdownHeights();
                this.setSlideMenuAttributes(slideMenu, secondaryNav, sitewideBanner);
                this.setCloseButtonPosition();
                this.adjustHeaderNav(secondaryNav, slideMenu, sitewideBanner, isBannerClosed);
            }));

            window.visualViewport.addEventListener('resize', () => {
                this.setSlideMenuAttributes(slideMenu, secondaryNav, sitewideBanner);
                this.setCloseButtonPosition();
                this.adjustHeaderNav(secondaryNav, slideMenu, sitewideBanner, isBannerClosed);
            });
        } else {

            // Window event listeners with debouncer
            window.addEventListener('resize', () => this.debouncer(() => {
                this.equalizeDropdownHeights();
                this.setSlideMenuAttributes(slideMenu, secondaryNav, sitewideBanner);
                this.setCloseButtonPosition();
                this.adjustHeaderNav(secondaryNav, slideMenu, sitewideBanner, isBannerClosed);
            }));
            //
            // window.addEventListener('resize', () => {
            //     this.setSlideMenuAttributes(slideMenu, secondaryNav, sitewideBanner);
            //     this.setCloseButtonPosition();
            //     this.adjustHeaderNav(secondaryNav, slideMenu, sitewideBanner, isBannerClosed);
            // });
        }

        if (infoDropdownBtn != null) {
            infoDropdownBtn.addEventListener("click", function () {
                window.open(infoDropdown!.options[infoDropdown.selectedIndex].value, '_parent');
            });
        }

        if (infoDropdown != null) {
            infoDropdown.addEventListener("change", function (e) {
                window.open((e.target as HTMLOptionElement).value, '_parent');
            });
        }
    }

    calculateCombinedHeight(secondaryNav: HTMLElement | null, sitewideBanner: HTMLElement | null): void {
        let sitewideBannerHeight = sitewideBanner ? sitewideBanner.clientHeight : 0;
        let secondaryNavHeight = secondaryNav ? secondaryNav.clientHeight : 0;
        let combinedHeight = window.innerWidth < 1200 ? sitewideBannerHeight : sitewideBannerHeight + secondaryNavHeight;
        let spacerHeight = sitewideBannerHeight + secondaryNavHeight;

        const fixedMenuSpacer = document.querySelector('.fixed-menu-spacer') as HTMLElement | null;
        if (fixedMenuSpacer) {
            fixedMenuSpacer.style.height = `${spacerHeight}px`;
        }
    }

    setSlideMenuAttributes(slideMenu: HTMLElement | null, secondaryNav: HTMLElement | null, sitewideBanner: HTMLElement | null): void {
        this.calculateCombinedHeight(secondaryNav, sitewideBanner);

        let secondaryNavHeight = secondaryNav ? secondaryNav.clientHeight : 0;
        let combinedHeight = window.innerWidth < 1200 ? (sitewideBanner ? sitewideBanner.clientHeight : 0) : (sitewideBanner ? sitewideBanner.clientHeight : 0) + secondaryNavHeight;
        const totalHeight = secondaryNavHeight;
        const slideMenuHeight = window.innerHeight - totalHeight;

        const mobileNavCloseButtons = document.querySelectorAll<HTMLElement>('.mobile-nav-close');

        if (slideMenu) {
            const slideMenuTop = window.scrollY >= combinedHeight ? secondaryNavHeight + 1 : totalHeight + 1;
            slideMenu.style.top = `${slideMenuTop}px`;
            slideMenu.style.height = `${slideMenuHeight - 1}px`;
        }

        const closeButtonTop = 18;
        mobileNavCloseButtons.forEach(btn => {
            btn.style.top = `${closeButtonTop}px`;
        });
    }

    insertContentIntoBlockerElement(elementId: string, content: string): void {
        const targetElement = document.getElementById(elementId);

        if (!targetElement) {
            console.error(`No element with ID "${elementId}" found.`);
            return;
        }

        targetElement.innerHTML = content;
    }

    updateBlockerElementWithContent(): void {
        const elementId = 'mm-0';
        const newContent = `
            <span class="mobile-nav-close">
                <span class="navbar-toggler-text">Close</span>
                <ion-icon name="close-outline"></ion-icon>
            </span>
        `;
        this.insertContentIntoBlockerElement(elementId, newContent);
    }

    setCloseButtonPosition(): void {
        const referenceElement = document.getElementById('slide-nav-toggle');

        if (!referenceElement) {
            console.error('Reference element not found.');
            return;
        }

        const rightPosition = window.innerWidth - referenceElement.getBoundingClientRect().right;

        document.querySelectorAll<HTMLElement>('.mobile-nav-close').forEach(element => {
            element.style.right = `${rightPosition}px`;
        });
    }

    handleMobileNavButtonVisibility(): void {
        const mobileNavToggleButton = document.getElementById('slide-nav-toggle') as HTMLElement;
        const mobileNavCloseButton = document.querySelector('.mobile-nav-close') as HTMLElement;
        const mm0Element = document.getElementById('mm-0');

        if (!mobileNavToggleButton || !mm0Element) {
            console.error('Required elements not found.');
            return;
        }

        const observer = new MutationObserver((mutationsList) => {
            requestAnimationFrame(() => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'attributes' && mutation.attributeName === 'inert') {
                        if (mm0Element.hasAttribute('inert')) {
                            mobileNavToggleButton.style.visibility = 'visible';
                            mobileNavCloseButton.style.display = 'none';
                        } else {
                            mobileNavToggleButton.style.visibility = 'hidden';
                            mobileNavCloseButton.style.display = 'inline-flex';
                        }
                        break;
                    }
                }
            })
        });

        observer.observe(mm0Element, { attributes: true });
    }

    mobileMenuBacklinksClasses(): void {
        const mmNavbars = document.querySelectorAll('.mm-navbar');

        mmNavbars.forEach((mmNavbar) => {
            const parent = mmNavbar.parentElement;

            const primary = parent?.querySelector('.primary');
            if (primary === mmNavbar.nextElementSibling) {
                mmNavbar.classList.add('primary');
            }

            const secondary = parent?.querySelector('.secondary');
            if (secondary === mmNavbar.nextElementSibling) {
                mmNavbar.classList.add('secondary');
            }

            const tertiary = parent?.querySelector('.tertiary');
            if (tertiary === mmNavbar.nextElementSibling) {
                mmNavbar.classList.add('tertiary');
            }
        });
    }

    changeTextContentOfBacklinks(selector: string, newContent: string): void {
        const elements = document.querySelectorAll(selector);

        elements.forEach((element: Element) => {
            element.textContent = newContent;
        });
    }

    assignFirstAndLastClasses(parentId: string, className: string): void {
        const container = document.getElementById(parentId);

        if (!container) {
            console.error(`No element with ID "${parentId}" found.`);
            return;
        }

        const items = container.getElementsByClassName(className);

        if (items.length === 0) {
            console.log(`No elements with the class "${className}" found.`);
            return;
        }

        for (let i = 0; i < items.length; i++) {
            const item = items[i] as HTMLElement;

            if (className === 'secondary' && item.classList.contains('label')) {
                continue;
            }

            if (item) {
                item.classList.add('first');
                break;
            }
        }

        if (items[items.length - 1]) {
            (items[items.length - 1] as HTMLElement).classList.add('last');
        }
    }

    assignFirstLastClassesToElements(): void {
        const parentId = 'mm-1';
        const classes = ['primary', 'secondary', 'tertiary'];

        classes.forEach((className) => {
            this.assignFirstAndLastClasses(parentId, className);
        });
    }

    equalizeDropdownHeights(): void {
        const topLevelDropdowns: NodeListOf<HTMLElement> = document.querySelectorAll('.main-nav .nav-item.dropdown');

        topLevelDropdowns.forEach(topDropdown => {
            const parentMenu: HTMLElement | null = topDropdown.querySelector('.main-nav .dropdown-menu');

            if (!parentMenu) return;

            const originalParentStyle = {
                display: parentMenu.style.display,
                visibility: parentMenu.style.visibility
            };

            parentMenu.style.display = 'block';
            parentMenu.style.visibility = 'hidden';

            const parentMenuHeight = parentMenu.getBoundingClientRect().height;

            parentMenu.style.display = originalParentStyle.display;
            parentMenu.style.visibility = originalParentStyle.visibility;

            const childSubmenus: NodeListOf<HTMLElement> = topDropdown.querySelectorAll('.main-nav .dropdown-submenu .dropdown-menu');

            childSubmenus.forEach(childSubmenu => {
                childSubmenu.style.minHeight = `${parentMenuHeight}px`;
            });
        });
    }

    desktopDropdownHandlers(): void {
        document.querySelectorAll('.main-nav .dropdown-submenu a.dropdown-toggle').forEach((element: HTMLAnchorElement) => {
            element.addEventListener('click', (e: Event) => {
                e.stopPropagation();
                e.preventDefault();

                const nextSibling = element.nextElementSibling as HTMLElement;
                if (nextSibling) {
                    element.closest('.dropdown-menu')?.querySelectorAll('.dropdown-menu.show').forEach((siblingSubmenu: HTMLElement) => {
                        if (siblingSubmenu !== nextSibling) {
                            siblingSubmenu.classList.remove('show');
                        }
                    });

                    const mainNavBottom = (document.querySelector<HTMLElement>('.main-nav')?.getBoundingClientRect().bottom) || 0;
                    const toggleLinkTop = element.getBoundingClientRect().top;
                    const desiredTop = mainNavBottom - toggleLinkTop;
                    nextSibling.style.top = `${desiredTop}px`;

                    nextSibling.classList.toggle('show');
                }
            });
        });

        document.querySelectorAll('.main-nav .nav-item.dropdown > a.dropdown-toggle').forEach((topLevelElement: HTMLAnchorElement) => {
            topLevelElement.addEventListener('click', () => {
                document.querySelectorAll('.main-nav .dropdown-submenu .dropdown-menu.show').forEach((submenu: HTMLElement) => {
                    submenu.classList.remove('show');
                });
            });
        });
    }

    adjustHeaderNav(secondaryNav: HTMLElement | null, slideMenu: HTMLElement | null, sitewideBanner: HTMLElement | null, isBannerClosed: boolean): void {
        this.calculateCombinedHeight(secondaryNav, sitewideBanner);
        const sitewideBannerHeight = sitewideBanner ? sitewideBanner.clientHeight : 0;
        let secondaryNavHeight = secondaryNav ? secondaryNav.clientHeight : 0;
        let combinedHeight = window.innerWidth < 1200 ? sitewideBannerHeight : sitewideBannerHeight + secondaryNavHeight;
        const totalHeight = secondaryNavHeight;
        const slideMenuHeight = window.innerHeight - totalHeight;

        const headerNav = document.querySelector<HTMLElement>('.header-nav');
        const logoWrapper = document.querySelector('.main-nav .logo-wrapper');
        const mobileNavCloseButtons = document.querySelectorAll<HTMLElement>('.mobile-nav-close');

        if (headerNav) {
            const resizer = () => {
                let slideMenuTop: number;
                if (window.innerWidth < 1200 && isBannerClosed) {
                    headerNav.style.transform = 'translateY(0px)';
                    slideMenuTop = secondaryNavHeight + 1;
                } else if (window.scrollY >= combinedHeight) {
                    headerNav.style.transform = `translateY(-${combinedHeight}px)`;

                    if (logoWrapper) {
                        logoWrapper.classList.add('logo-show');
                    }
                    slideMenuTop = secondaryNavHeight + 1;
                } else {
                    headerNav.style.transform = `translateY(0px)`;

                    if (logoWrapper) {
                        logoWrapper.classList.remove('logo-show');
                    }
                    slideMenuTop = totalHeight + 1;
                }

                if (slideMenu) {
                    slideMenu.style.top = `${slideMenuTop}px`;
                    slideMenu.style.height = window.scrollY >= combinedHeight ? `${slideMenuHeight + combinedHeight - 1}px` : `${slideMenuHeight - 1}px`;
                }
            };

            window.addEventListener('resize', () => {
                resizer();
            }, true);
            resizer();

            const closeButtonTop = 18;
            mobileNavCloseButtons.forEach(btn => {
                btn.style.top = `${closeButtonTop}px`;
            });
        }
    }

    debouncer(fn: Function, delay = 250) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = window.setTimeout(() => {
            fn();
        }, delay);
    }

    throttle(func: Function, wait: number) {
        let context: any, args: any, result: any;
        let previous = 0;

        return function() {
            let now;
            if ((now = Date.now() - previous) < wait) {
                clearTimeout(context);
                context = setTimeout(() => {
                    previous = now;
                    result = func.apply(this, args);
                }, wait - now);
            } else {
                previous = now;
                result = func.apply(this, args);
            }
            return result;
        };
    }

    // not used ... ?

    isMobile(): boolean {
        let vw = window.innerWidth;
        return vw <= 992;
    }

    goToPage(url: string): void {
        window.open(url, '_parent');
    }
}

export default Header;
